import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useSiteImages, slot, INSTAGRAM_SLOTS } from "@/lib/siteImages";

const FALLBACKS = [
  { img: "/images/portfolio-jateado.webp", alt: "Trabalho da Bella Film RJ: película jateada em porta de vidro" },
  { img: "/images/portfolio-fume-porta.webp", alt: "Trabalho da Bella Film RJ: película fumê em porta de vidro" },
  { img: "/images/portfolio-fachada.webp", alt: "Trabalho da Bella Film RJ: película de controle solar em fachada" },
  { img: "/images/portfolio-espelhada.webp", alt: "Trabalho da Bella Film RJ: película espelhada em porta de vidro" },
];

export function InstagramHome() {
  const images = useSiteImages();
  const photos = INSTAGRAM_SLOTS.map((k, i) => slot(images, k, FALLBACKS[i].img, FALLBACKS[i].alt));
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % photos.length), 3500);
    return () => clearInterval(t);
  }, [photos.length]);

  return (
    <section className="order-5 bg-white py-14 md:order-none md:py-32" data-testid="instagram-home-section" aria-labelledby="instagram-home-titulo">
      <div className="mx-auto grid max-w-7xl items-center gap-8 px-5 md:grid-cols-2 md:gap-16 md:px-12">
        <Reveal>
          <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-aqua">Instagram</p>
          <h2 id="instagram-home-titulo" className="mt-3 font-display text-xl font-bold tracking-tight text-navy md:mt-4 md:text-5xl">
            Trabalhos reais, direto do nosso Instagram
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-navy/65 md:mt-4 md:text-base">
            Siga <span className="font-semibold text-navy">@bellafilmrj</span> e veja aplicações recentes em residências,
            empresas e veículos em toda a cidade do Rio de Janeiro.
          </p>
          <a href="https://www.instagram.com/bellafilmrj/" target="_blank" rel="noopener noreferrer"
             data-testid="instagram-home-cta"
             className="mt-6 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 font-display text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-bella hover:shadow-lg md:mt-8">
            <Instagram size={17} /> Ver nossos trabalhos no Instagram
          </a>
          <div className="mt-5 flex gap-2" role="tablist" aria-label="Fotos do Instagram">
            {photos.map((_, i) => (
              <button key={i} role="tab" aria-selected={idx === i} data-testid={`instagram-home-dot-${i}`}
                      onClick={() => setIdx(i)} aria-label={`Ver foto ${i + 1}`}
                      className={`h-2.5 rounded-full transition-all ${idx === i ? "w-7 bg-aqua" : "w-2.5 bg-navy/20 hover:bg-navy/40"}`} />
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="relative aspect-square overflow-hidden rounded-2xl shadow-xl md:aspect-[4/5]" data-testid="instagram-home-foto">
            {photos.map((p, i) => (
              <img key={i} src={p.src} alt={p.alt} loading="lazy"
                   className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
